import React from 'react';
import PropTypes from 'prop-types';
import styles from './FlavorSpectrum.module.css';

export const FlavorSpectrum = ({ title, gradient }) => {
  return (
    <div className={styles.spectrumContainer}>
      <div className={styles.cardBackground} />
      <div className={styles.spectrumContent}>
        <div className={styles.spectrumTitle}>{title}</div>
      </div>
      <div className={styles.spectrumBar} style={{ background: gradient }} />
    </div>
  );
};

FlavorSpectrum.propTypes = {
  title: PropTypes.string.isRequired,
  gradient: PropTypes.string.isRequired
};
